const getters = {
    itemBalances: (state) => state.itemBalances,    
    loading: state => state.loading
};

export default getters;